module.exports = __webpack_public_path__ + "media/images/icon/icons8-Close Window-5614838811a3e59a7c96cb361d4fbf3e.png";